module.exports = __webpack_public_path__ + "static/media/FOO.da24d3a7.png";